export function toFloat(val) {return parseFloat(val) || 0;}